const CHAT_DATE_LOCALES = {
  en: "en-US",
  ru: "ru-RU",
  sk: "sk-SK",
  cs: "cs-CZ",
};

export function formatChatHeaderEventDate(value, eventType, { language = "en", t } = {}) {
  const conceptLabel = t?.("chats.event_chat.concept_label", { defaultValue: "Concept" }) || "Concept";
  const normalizedType = String(eventType || "").trim().toLowerCase();
  if (normalizedType === "concept" || !value) return conceptLabel;

  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return conceptLabel;

  const languageCode = String(language || "en").toLowerCase().split("-")[0];
  const locale = CHAT_DATE_LOCALES[languageCode] || CHAT_DATE_LOCALES.en;
  const dateLabel = new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
  }).format(date);
  const timeLabel = `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

  return t?.("chats.event_chat.header_date", {
    date: dateLabel,
    time: timeLabel,
    defaultValue: `${dateLabel} at ${timeLabel}`,
  }) || `${dateLabel} at ${timeLabel}`;
}
